<div class="main-group">
	<!--			-->
	<!-- Item Count -->
	<!--			-->
	<div class="main-group-item">
		<div class="main-group-item-center">
			<label class="label-item-name">{{ PersonName }}</label>
		</div>
	</div>

	<!-- 				  -->
	<!-- Printer Selector -->
	<!-- 				  -->
	<div class="main-group-item">
		<div class="selector-item">
			<div>
				<label class="label-item-sel">Card Printer</label>
			</div>

			<div style="margin-left: 10px; width: 350px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="PrinterSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedPrinter"
					(ngModelChange)="onPrinterChange($event)"
				>
					<option *ngFor="let r of lstPrinter" [ngValue]="r">{{ r.PrinterName }} - {{ r.ScanStation }}</option>
				</select>
			</div>
		</div>
	</div>

	<!-- 			   -->
	<!-- Card Selector -->
	<!-- 		  	   -->
	<div class="main-group-item">
		<div class="selector-item">
			<div>
				<label class="label-item-sel">Card Name</label>
			</div>

			<div style="margin-left: 10px; width: 350px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="TemplateSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedTemplate"
					(ngModelChange)="onTemplateChange($event)"
				>
					<option *ngFor="let r of lstTemplate" [ngValue]="r">
						{{ r.CardName }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!-- 		   -->
	<!-- Print Fee -->
	<!-- 		   -->
	<div class="main-group-item">
		<div class="check-items">
			<div style="width: 85px"></div>
			<!-- Spacer -->

			<div style="margin-left: 3px">
				<!-- Account for CSS transform: scale(1.5) -->
				<input type="checkbox" name="checkbox1" [(ngModel)]="IsChargePrintFee" ngDefaultControl />
			</div>

			<div style="margin-left: 10px">
				<label class="check-items-label">Charge {{ PrintFee | currency : "USD" }} print fee</label>
			</div>
		</div>
	</div>

	<!-- 		   		-->
	<!-- Print Priority -->
	<!-- 		 		-->
	<div class="main-group-item">
		<div class="radio-items">
			<div style="width: 85px"></div>
			<!-- Spacer -->

			<div>
				<p-radioButton name="prioritygroup" (click)="onPrintPriority($event)" [(ngModel)]="SelectedPriority" value="0"> </p-radioButton>
			</div>

			<div style="margin-left: 5px">
				<label class="radio-items-label">Print Now</label>
			</div>

			<div style="margin-left: 15px">
				<p-radioButton name="prioritygroup" (click)="onPrintPriority($event)" [(ngModel)]="SelectedPriority" value="1"> </p-radioButton>
			</div>

			<div style="margin-left: 5px">
				<label class="radio-items-label">Add to Queue</label>
			</div>
		</div>
	</div>

	<!--	   -->
	<!-- Notes -->
	<!--	   -->
	<div class="main-group-item">
		<div>
			<!-- Notes -->
			<div>
				<label class="label-item-note">Note:</label>
			</div>
			<div>
				<label style="margin-left: 10px">Print Now - Prints immediately.</label>
			</div>
			<div>
				<label style="margin-left: 10px">Add to Queue - Will print after existing cards in queue are printed.</label>
			</div>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="main-group-item" [style.display]="ErrorMessage != '' ? 'block' : 'none'">
		<div>
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" [disabled]="isBusy == true || isOneCardExpressOperator == true" (click)="onPrint()">Print</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
